"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2250],{

/***/ 1452:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function SvgAmazon(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "#3023E6",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M4.044 21.437c.073-.114.187-.122.347-.023 3.638 2.05 7.598 3.08 11.875 3.08 2.855 0 5.67-.52 8.453-1.551l.314-.136c.138-.06.234-.098.293-.127.226-.087.39-.043.524.127.123.166.092.325-.12.465-.255.184-.599.399-1.006.635-1.244.72-2.641 1.279-4.186 1.678a18.253 18.253 0 01-4.52.591c-2.265 0-4.412-.384-6.436-1.152a17.927 17.927 0 01-5.432-3.257c-.1-.071-.15-.143-.15-.215 0-.045.02-.086.05-.126l-.006.011zm6.569-6.042c0-.978.248-1.81.742-2.506.496-.69 1.17-1.212 2.041-1.567.799-.327 1.756-.56 2.913-.701.391-.043 1.032-.1 1.918-.17v-.36c0-.9-.1-1.513-.297-1.821-.302-.418-.78-.63-1.442-.63h-.18c-.48.045-.894.188-1.245.446a1.752 1.752 0 00-.677 1.066c-.058.292-.206.451-.432.496l-2.524-.307c-.25-.06-.373-.175-.373-.38 0-.043.008-.086.022-.143.25-1.255.857-2.19 1.822-2.8.976-.598 2.1-.947 3.39-1.018h.541c1.653 0 2.96.42 3.889 1.253.138.143.272.291.407.463.12.162.226.308.281.44.076.129.152.32.197.552.06.249.105.41.135.497.028.1.061.29.077.598.007.305.019.477.019.537v5.13c0 .366.059.701.164 1.008.106.302.209.525.314.655l.513.653a.684.684 0 01.133.353c0 .119-.058.22-.177.303-1.201 1.021-1.862 1.574-1.965 1.663-.164.131-.375.145-.63.045a6.427 6.427 0 01-.526-.482l-.309-.339c-.06-.073-.169-.202-.319-.41l-.3-.422c-.81.861-1.603 1.403-2.4 1.622-.496.145-1.095.219-1.832.219-1.11 0-2.04-.332-2.761-1.005-.717-.67-1.08-1.618-1.08-2.857l-.05-.073v-.008zm3.753-.427c0 .553.14.992.426 1.326.283.332.675.498 1.156.498.042 0 .106-.01.192-.02.094-.015.133-.024.17-.024.613-.155 1.08-.537 1.425-1.144a3 3 0 00.358-.882c.091-.312.12-.575.133-.776.02-.193.02-.527.02-.978v-.525c-.843 0-1.487.057-1.923.172-1.275.353-1.923 1.138-1.923 2.363l-.035-.019v.009h.001zm9.166 6.829c.03-.06.076-.107.13-.166a3.61 3.61 0 011.052-.485 8.128 8.128 0 011.611-.234c.14-.012.28 0 .415.03.646.058 1.047.163 1.171.317.064.09.089.223.089.382v.146c0 .496-.14 1.078-.417 1.748-.277.671-.663 1.213-1.155 1.633-.073.057-.137.086-.196.086-.03 0-.061 0-.089-.011-.091-.043-.108-.117-.066-.234.54-1.224.806-2.081.806-2.563 0-.148-.03-.265-.089-.337-.143-.16-.548-.253-1.223-.253-.29.005-.582.02-.871.046-.363.048-.698.09-1 .134-.089 0-.148-.017-.18-.043-.03-.03-.037-.046-.021-.075 0-.016.007-.029.021-.062V21.8l.012-.002z"
  })));
}
/* harmony default export */ __webpack_exports__["Z"] = (SvgAmazon);

/***/ }),

/***/ 3168:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function SvgDeezer(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M4 20.002h6V24H4v-3.998zm6 0h6V24h-6v-3.998zm6 0h6V24h-6v-3.998zm6 0h6V24h-6v-3.998zm-12-3.999h6v3.999h-6v-3.999zm6 0h6v3.999h-6v-3.999zm6 0h6v3.999h-6v-3.999zm-12-3.998h6v3.998h-6v-3.998zm12 0h6v3.998h-6v-3.998zM22 8h6v3.998h-6V8z",
    stroke: "#3369FF",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
/* harmony default export */ __webpack_exports__["Z"] = (SvgDeezer);

/***/ }),

/***/ 3766:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function SvgPodcastapple(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M18.6 17.431c.598-.646.93-1.495.93-2.376a3.53 3.53 0 10-7.06 0c0 .88.332 1.73.93 2.376a2.611 2.611 0 00-.87.694 2.566 2.566 0 00-.542 2.142l1.13 5.646a2.6 2.6 0 002.54 2.083h.683a2.6 2.6 0 002.541-2.082l1.13-5.648a2.565 2.565 0 00-.541-2.14 2.612 2.612 0 00-.871-.695v0zM16 12.937a2.118 2.118 0 11-2.118 2.118A2.13 2.13 0 0116 12.937zm2.623 7.059l-1.129 5.647a1.188 1.188 0 01-1.153.941h-.682a1.189 1.189 0 01-1.153-.941l-1.13-5.647a1.163 1.163 0 01.248-.977 1.14 1.14 0 01.905-.435h2.942a1.14 1.14 0 01.905.435 1.166 1.166 0 01.247.977v0zm4.2-4a6.824 6.824 0 10-13.188 2.47.706.706 0 01-.4.918 1 1 0 01-.259.047.706.706 0 01-.658-.459 8.235 8.235 0 1115.364 0 .717.717 0 01-.917.412.717.717 0 01-.4-.918c.305-.788.46-1.625.459-2.47zm5.177 0a11.966 11.966 0 01-5.541 10.117.73.73 0 01-.377.106.693.693 0 01-.701-.574.709.709 0 01.313-.72 10.589 10.589 0 10-11.388 0 .707.707 0 01-.765 1.188A12 12 0 1128 15.996v0z",
    fill: "#E360F5",
    stroke: "#E360F5",
    strokeWidth: 0.3
  })));
}
/* harmony default export */ __webpack_exports__["Z"] = (SvgPodcastapple);

/***/ }),

/***/ 2869:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function SvgSpotify(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M16 4a12 12 0 1012 12A12.012 12.012 0 0016 4v0zm0 22.588A10.588 10.588 0 1126.588 16 10.6 10.6 0 0116 26.588zm6.635-12.576a.717.717 0 01-.953.306 12.471 12.471 0 00-11.388 0 .646.646 0 01-.33.082.706.706 0 01-.317-1.341A13.94 13.94 0 0116 11.529a13.73 13.73 0 016.33 1.53.706.706 0 01.305.953v0zm-1.74 3.33a.706.706 0 01-.954.317 8.67 8.67 0 00-7.906 0 .8.8 0 01-.317.082.706.706 0 01-.33-1.341 10.118 10.118 0 019.2 0 .706.706 0 01.306.941v0zm-1.742 3.34a.717.717 0 01-.953.306 4.918 4.918 0 00-2.2-.517 4.835 4.835 0 00-2.223.529.718.718 0 01-.953-.318.695.695 0 01.317-.94A6.166 6.166 0 0116 19.058a6.248 6.248 0 012.835.67.708.708 0 01.318.953v0z",
    fill: "#2BD05F",
    stroke: "#2BD05F",
    strokeWidth: 0.4
  })));
}
/* harmony default export */ __webpack_exports__["Z"] = (SvgSpotify);

/***/ }),

/***/ 7517:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Breadcrumb; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/hub.js + 9 modules
var hub = __webpack_require__(5877);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./src/components/Layout/Breadcrumb/styles.tsx




var BreadcrumbItemContainer = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: "flex flex-row items-center font-light text-mglGray500 before:mr-2 before:flex before:h-[13px] before:w-2 before:items-center before:justify-center before:pb-[3px] before:text-center before:text-base before:leading-none before:content-['›'] first-of-type:before:content-none"
    }, props), {
        children: props.children
    }));
};
var BreadcrumbItem = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: "flex h-4 flex-row items-center text-xs leading-4 text-mglGray500 no-underline"
    }, props), {
        ref: ref,
        children: props.children
    }));
});


// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(1752);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
;// CONCATENATED MODULE: ./src/components/Layout/Breadcrumb/index.tsx
/* eslint-disable react/no-array-index-key */ 





var publicRuntimeConfig = config_default()().publicRuntimeConfig;
function Breadcrumb(param) {
    var breadcrumbList = param.breadcrumbList, _isSubDomain = param.isSubDomain, isSubDomain = _isSubDomain === void 0 ? false : _isSubDomain;
    var ref;
    var currentSpan = (ref = (0,hub/* getCurrentHub */.Gd)().getScope()) === null || ref === void 0 ? void 0 : ref.getSpan();
    var breadcrumbSpan = currentSpan && currentSpan.startChild({
        op: "breadcrumb"
    });
    var workingList = (0,_to_consumable_array/* default */.Z)(breadcrumbList).filter(function(item) {
        return item.url !== "/";
    });
    workingList.unshift({
        titulo: "Home",
        url: "/"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "place-content-[center_start] mb-2 flex flex-wrap items-center gap-2",
        children: [
            workingList.map(function(item) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadcrumbItemContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: isSubDomain ? "".concat(publicRuntimeConfig.NEXT_PUBLIC_URL).concat(item.url) : item.url,
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadcrumbItem, {
                            title: "Ir para ".concat(item.titulo),
                            children: item.titulo
                        })
                    })
                }, item.url);
            }),
            breadcrumbSpan && breadcrumbSpan.finish()
        ]
    });
}


/***/ }),

/***/ 2384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Chip; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9659);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6008);







var variants = {
    sizes: {
        small: "h-6",
        medium: "h-9",
        large: "h-12"
    },
    backgroundColor: {
        white: "chip-bg-color [&.chip-bg-color]:bg-mglGray50",
        black: "chip-bg-color [&.chip-bg-color]:bg-mglGray900",
        green: "chip-bg-color [&.chip-bg-color]:bg-mglGreen500"
    },
    color: {
        black: "text-mglGray900",
        white: "chip-color [&.chip-color]:text-mglGray50 [&.chip-color]:[&_svg]:fill-mglGray50"
    },
    hover: {
        white: "chip-hover-color hover:[&.chip-hover-color]:bg-mglGray50 hover:[&.chip-hover-color]:text-mglGray900 [&.chip-hover-color]:hover:[&_path]:fill-mglGray900",
        black: "chip-hover-color hover:[&.chip-hover-color]:bg-mglGray900 hover:[&.chip-hover-color]:text-mglGray50 [&.chip-hover-color]:hover:[&_path]:fill-mglGray50",
        gray: "chip-hover-color hover:[&.chip-hover-color]:bg-mglGray200 hover:[&.chip-hover-color]:text-mglGray900 [&.chip-hover-color]:hover:[&_path]:fill-mglGray900",
        green: "chip-hover-color hover:[&.chip-hover-color]:bg-mglGreen600 hover:[&.chip-hover-color]:text-mglGray50 [&.chip-hover-color]:hover:[&_path]:fill-mglGray50"
    },
    borderColor: {
        gray: "chip-border-color [&.chip-border-color]:border-mglGray900/20 hover:[&.chip-border-color]:border-mglGray50",
        black: "border-mglGray900/20",
        white: "chip-border-color [&.chip-border-color]:border-mglGray50/20",
        green: "chip-border-color [&.chip-border-color]:border-mglGreen500 hover:[&.chip-border-color]:border-mglGreen600"
    }
};
function Chip(param) {
    var texto = param.texto, prepIcon = param.prepIcon, posIcon = param.posIcon, _link = param.link, link = _link === void 0 ? "#" : _link, _color = param.color, color = _color === void 0 ? undefined : _color, _backgroundColor = param.backgroundColor, backgroundColor = _backgroundColor === void 0 ? undefined : _backgroundColor, backgroundImage = param.backgroundImage, _overlayOpacity = param.overlayOpacity, overlayOpacity = _overlayOpacity === void 0 ? 60 : _overlayOpacity, _chipSize = param.chipSize, chipSize = _chipSize === void 0 ? "small" : _chipSize, _borderColor = param.borderColor, borderColor = _borderColor === void 0 ? undefined : _borderColor, _title = param.title, title = _title === void 0 ? "" : _title, _highlightedText = param.highlightedText, highlightedText = _highlightedText === void 0 ? "" : _highlightedText, className = param.className, onClick = param.onClick, _hover = param.hover, hover = _hover === void 0 ? undefined : _hover, _rel = param.rel, rel = _rel === void 0 ? "" : _rel, _target = param.target, target = _target === void 0 ? "_self" : _target;
    var isValidLink = link[0] !== "#" && !/^\/\//.test(link) && link !== "";
    var Container = isValidLink ? (next_link__WEBPACK_IMPORTED_MODULE_2___default()) : react__WEBPACK_IMPORTED_MODULE_1__.Fragment;
    var Tag = link !== "#" && link !== "" ? "a" : "div";
    var linkProps = {};
    if (isValidLink) {
        Object.assign(linkProps, {
            href: link,
            passHref: true,
            prefetch: false
        });
    }
    var backgroundStyle = backgroundImage ? {
        backgroundImage: "linear-gradient(rgba(0, 0, 0, ".concat(overlayOpacity / 100, "), rgba(0, 0, 0, ").concat(overlayOpacity / 100, ")), url(").concat(backgroundImage, ")"),
        backgroundSize: "cover",
        backgroundPosition: "center"
    } : {};
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Container, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, linkProps), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Tag, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, link && link !== "#" && {
            href: link
        }), {
            className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("relative flex cursor-pointer flex-row flex-nowrap items-center justify-center overflow-hidden rounded-[100px] border border-solid px-4 no-underline transition-all ease-in [&_path]:transition-colors [&_path]:ease-ease", variants.sizes[chipSize], !backgroundImage && variants.backgroundColor[backgroundColor], variants.color[color], variants.borderColor[borderColor], variants.hover[hover], backgroundImage && "text-white", className),
            style: backgroundStyle,
            rel: rel,
            title: title,
            onClick: onClick,
            target: target,
            children: [
                !!prepIcon && typeof prepIcon === "string" && (prepIcon === "chevron-down" || prepIcon === "chevron-right") ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "relative -m-1 flex pr-1",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        icon: "mdi:".concat(prepIcon),
                        width: 16
                    })
                }) : !!prepIcon && typeof prepIcon !== "string" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "relative -m-1 flex pr-1",
                    children: prepIcon
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex flex-col",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "relative mt-[-2px] whitespace-nowrap text-center text-xs no-underline",
                            children: texto
                        }),
                        !!highlightedText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "text-base font-semibold leading-none",
                            children: highlightedText
                        })
                    ]
                }),
                !!posIcon && typeof posIcon === "string" && (posIcon === "chevron-down" || posIcon === "chevron-right") ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "relative -m-1 flex pl-1 [&_svg]:w-4",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        icon: "mdi:".concat(posIcon),
                        width: 16
                    })
                }) : !!posIcon && typeof posIcon !== "string" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "relative -m-1 flex pl-1",
                    children: posIcon
                })
            ]
        }))
    }));
}


/***/ }),

/***/ 1080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Container; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9659);


function Container(param) {
    var children = param.children, _hasBreadcrumb = param.hasBreadcrumb, hasBreadcrumb = _hasBreadcrumb === void 0 ? false : _hasBreadcrumb, _className = param.className, className = _className === void 0 ? "" : _className;
    var variants = {
        hasBreadcrumb: {
            true: "mt-4 desktop:mt-10",
            false: ""
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("w-full max-w-[calc(100%-2rem)] desktop:max-w-[83.33%]", variants.hasBreadcrumb[hasBreadcrumb.toString()], className),
        children: children
    });
}


/***/ }),

/***/ 2747:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "bL": function() { return /* binding */ BillboardContainer; },
/* harmony export */   "g1": function() { return /* binding */ AdContainer; },
/* harmony export */   "hn": function() { return /* binding */ ContentListNews; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9659);





var variants = {
    AdContainer: {
        noPadding: {
            true: "noPadding [&.noPadding]:p-0"
        },
        billboard: {
            true: "h-[250px] hidden tablet:flex"
        }
    },
    ContentListNews: {
        singleRow: {
            true: "grid-rows-[auto]"
        }
    }
};
var AdContainer = function(_param) {
    var children = _param.children, noPadding = _param.noPadding, billboard = _param.billboard, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children",
        "noPadding",
        "billboard"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("flex min-h-0 items-center justify-center bg-mglGray50 px-0 py-5", noPadding != undefined && variants.AdContainer.noPadding[noPadding.toString()], billboard != undefined && variants.AdContainer.billboard[billboard.toString()])
    }, rest), {
        children: children
    }));
};
var ContentListNews = function(_param) {
    var children = _param.children, singleRow = _param.singleRow, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children",
        "singleRow"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("ml-0 grid grid-cols-1 grid-rows-2 gap-5 [grid-auto-columns:1fr] tablet:ml-auto tablet:grid-cols-2 desktop:grid-cols-3 [&_a]:mx-0 [&_a]:my-5 [&_a]:no-underline ", singleRow != undefined && variants.ContentListNews.singleRow[singleRow.toString()])
    }, rest), {
        children: children
    }));
};
var BillboardContainer = function(_param) {
    var children = _param.children, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: "m-0 hidden tablet:mx-[-8.335%] tablet:my-0 tablet:flex"
    }, rest), {
        children: children
    }));
};


/***/ }),

/***/ 2835:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ NewsTimeLine; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5877);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9659);
/* harmony import */ var _styles_designSystemColors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9642);
/* harmony import */ var _Image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2153);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6008);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1752);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_5__);
/* eslint-disable jsx-a11y/anchor-is-valid */ 







var publicRuntimeConfig = next_config__WEBPACK_IMPORTED_MODULE_5___default()().publicRuntimeConfig;
var icons = {
    video: "mdi:video",
    podcast: "mdi:microphone",
    webStories: "mdi:view-carousel"
};
function NewsTimeLine(param) {
    var news = param.news, _image = param.image, image = _image === void 0 ? true : _image, _effectImage = param.effectImage, effectImage = _effectImage === void 0 ? true : _effectImage, _title = param.title, title = _title === void 0 ? true : _title, propsTitle = param.propsTitle, _autor = param.autor, autor = _autor === void 0 ? false : _autor, propsAutor = param.propsAutor, metaInfo = param.metaInfo, propsMetaInfo = param.propsMetaInfo, _isSubDomain = param.isSubDomain, isSubDomain = _isSubDomain === void 0 ? false : _isSubDomain, _url = param.url, url = _url === void 0 ? null : _url, _headingTag = param.headingTag, headingTag = _headingTag === void 0 ? "h2" : _headingTag;
    var ref;
    var variants = {
        ItemList: {
            effectImage: {
                true: "[&_.image-container]:hover:scale-105",
                false: ""
            },
            colorInHover: {
                true: "transition-colors duration-300 ease-ease [&_h3]:hover:text-mglBlue400",
                false: ""
            }
        },
        Image: {
            imgRounded: {
                true: "rounded-half border-[3px] border-solid border-mglGray200",
                false: ""
            }
        },
        Title: {
            autorNoMargin: {
                true: "tablet:m-0 mt-0",
                false: ""
            }
        }
    };
    var currentSpan = (ref = (0,_sentry_nextjs__WEBPACK_IMPORTED_MODULE_6__/* .getCurrentHub */ .Gd)().getScope()) === null || ref === void 0 ? void 0 : ref.getSpan();
    var newsListContainerSpan = currentSpan && currentSpan.startChild({
        op: "newsListContainer"
    });
    var Heading = headingTag;
    url || (url = news.url);
    if (isSubDomain && !url.match(/^https?:/)) {
        url = "".concat(publicRuntimeConfig.NEXT_PUBLIC_URL).concat(url);
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("article", {
        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("relative mx-0 mb-0 mt-4 hover:cursor-pointer tablet:my-4 [&_a]:text-[inherit]", propsTitle.altColorInHover && !!propsTitle.colorHover && variants.ItemList.colorInHover[(propsTitle.altColorInHover && !!propsTitle.colorHover).toString()], effectImage != undefined && variants.ItemList.effectImage[effectImage.toString()]),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                href: url,
                passHref: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                    rel: news.id,
                    title: news.titulo,
                    className: "jc",
                    children: [
                        image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "box relative flex overflow-hidden rounded-lg",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "image-container relative flex h-full w-full transition-transform duration-300 ease-ease [&>figure]:aspect-video",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                        src: news.imagem.url,
                                        alt: news.titulo,
                                        blurhash: news.imagem.blurhash
                                    })
                                }),
                                autor && propsAutor && propsAutor.image && propsAutor.imgInImage && news.colunista && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "absolute bottom-2 left-2 h-10 w-10",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("h-auto w-full object-cover", propsAutor.imgRounded != null && variants.Image.imgRounded[propsAutor.imgRounded.toString()]),
                                        src: news.colunista.imagem.url,
                                        alt: news.autor,
                                        width: 40,
                                        height: 40
                                    })
                                }),
                                (news.tipo === "video" || news.tipo === "webStories" || news.tipo === "podcast") && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "absolute bottom-[10px] left-[10px] z-[2] flex h-10 w-10 items-center justify-center rounded-half border-[6px] border-solid border-[#999] bg-[#999] text-[2.5rem]",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                        icon: icons[news.tipo],
                                        width: "1em",
                                        color: _styles_designSystemColors__WEBPACK_IMPORTED_MODULE_2__/* .mglGray.mglGray50 */ .Ce.mglGray50
                                    })
                                })
                            ]
                        }),
                        autor && propsAutor && propsAutor.image && !propsAutor.imgInImage && news.colunista && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "relative -bottom-2 mb-4 ml-0 mr-2 mt-0 inline-block h-10 w-10",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("h-auto w-full object-cover", propsAutor.imgRounded != null && variants.Image.imgRounded[propsAutor.imgRounded.toString()]),
                                src: news.colunista.imagem.url,
                                alt: news.autor
                            })
                        }),
                        autor && propsAutor && propsAutor.text && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "mx-0 mb-2 mt-4 inline-block text-xs text-black/40",
                            children: news.autor
                        }),
                        metaInfo && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "mb-[10px] mt-5 flex flex-row text-xs leading-none",
                            children: [
                                propsMetaInfo && propsMetaInfo.age && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                    className: "flex flex-row items-center font-medium text-black/40 [&_svg]:mr-[2px]",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                            icon: "mdi:clock-outline",
                                            width: "12",
                                            height: "12"
                                        }),
                                        news.idade
                                    ]
                                }),
                                propsMetaInfo && propsMetaInfo.age && propsMetaInfo.category && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "mx-1 my-0 h-auto border-0 border-l-[0.5px] border-solid border-[#999]"
                                }),
                                propsMetaInfo && propsMetaInfo.category && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "font-medium uppercase text-black/40",
                                    children: news.categoria
                                })
                            ]
                        }),
                        title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Heading, {
                            className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("mt-4 text-lg font-medium text-mglGray900 tablet:mx-0 tablet:mb-0", (propsAutor && !!propsAutor.text || metaInfo && !!propsMetaInfo) && variants.Title.autorNoMargin.true),
                            style: propsTitle.color ? {
                                color: propsTitle.color
                            } : {},
                            children: news.titulo
                        })
                    ]
                })
            }),
            newsListContainerSpan && newsListContainerSpan.finish()
        ]
    });
}


/***/ }),

/***/ 9211:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ PodcastItem; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./public/images/porta101.svg
var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function SvgPorta101(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 198,
    height: 217,
    viewBox: "0 0 198 217",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M101.431 102.602c-7.52 0-12.341 4.941-12.341 14.581v30.112c0 9.649 4.82 14.582 12.341 14.582 7.521 0 12.342-4.942 12.342-14.582v-30.112c0-9.64-4.821-14.581-12.342-14.581zM110.612 5.202L11.495 0l-.554 10.429 99.671-5.227z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M179.639 8.818l3.479 66.382L7.026 84.429 0 217l49.869-27.838.402.025v-85.058H39.104V91.074H66.25v98.944l121.973 6.393L198 9.783l-18.361-.965zM32.354 175.05a6.629 6.629 0 010-13.257 6.629 6.629 0 010 13.257zm97.525-26.228c0 16.227-11.52 26.228-28.439 26.228-16.92 0-28.322-10.001-28.322-26.228v-33.165c0-16.227 11.403-26.228 28.322-26.228 16.919 0 28.439 10.001 28.439 26.228v33.165zm30.3 24.583h-15.98v-69.276h-11.168V91.074h27.148V173.405zM65.748 38.108c-.226-4.246-3.194-6.293-6.724-6.108-3.58.184-6.271 2.533-6.053 6.779l.662 12.677c.218 4.195 3.153 6.293 6.724 6.108 3.53-.184 6.272-2.584 6.054-6.779l-.663-12.677zM95.638 36.748c-.218-4.144-2.146-5.83-5.525-5.654l-6.64.352.662 12.627 6.64-.352c3.37-.177 5.115-2.165 4.897-6.31l-.034-.663zM35.574 40.356c-.218-4.195-2.172-6.292-5.55-6.116l-6.64.352.729 13.91 6.64-.352c3.37-.176 5.097-2.525 4.88-6.712l-.06-1.074v-.008z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M139 44.366l8.376-.436-4.938-13.072L139 44.366z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/react.createElement("path", {
    d: "M172.571 9.086L.201 18.131l3.11 59.452 172.37-9.036-3.11-59.452v-.009zM31.063 53.923l-6.64.352.537 10.278-7.102.37L15.98 29.13l13.742-.721c7.613-.403 12.55 3.85 12.92 10.957l.117 2.299c.369 7.106-4.091 11.855-11.704 12.25l.008.008zm29.605 9.472c-7.513.394-13.776-3.742-14.153-10.949l-.73-13.96c-.377-7.208 5.417-11.923 12.93-12.317 7.461-.395 13.716 3.691 14.093 10.898l.73 13.961c.377 7.207-5.417 11.973-12.879 12.367h.009zm36.278-2.617l-7.403-11.302-5.106.269.612 11.662-7.102.369-1.878-35.792 13.742-.722c7.613-.402 12.526 3.34 12.895 10.505l.1 1.887c.26 4.909-1.903 8.718-6.22 10.329l8.593 12.367-8.225.428h-.008zm18.336-.965L113.714 29.8l-9.407.495-.302-5.78 25.907-1.36.302 5.781-9.398.495 1.567 30.011-7.101.37zm37.376-1.964l-3.261-8.49-11.805.62-2.205 8.785-7.462.394 10.849-36.463 6.741-.352 14.647 35.12-7.512.395.008-.009z",
    fill: "#fff"
  })));
}
/* harmony default export */ var porta101 = (SvgPorta101);
;// CONCATENATED MODULE: ./public/images/canaltech-podcast-branco.svg
var _style, canaltech_podcast_branco_path, canaltech_podcast_branco_path2, canaltech_podcast_branco_path3, _g;
var canaltech_podcast_branco_excluded = ["title", "titleId"];
function canaltech_podcast_branco_extends() { canaltech_podcast_branco_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return canaltech_podcast_branco_extends.apply(this, arguments); }
function canaltech_podcast_branco_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = canaltech_podcast_branco_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function canaltech_podcast_branco_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function SvgCanaltechPodcastBranco(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = canaltech_podcast_branco_objectWithoutProperties(_ref, canaltech_podcast_branco_excluded);
  return /*#__PURE__*/react.createElement("svg", canaltech_podcast_branco_extends({
    id: "canaltech-podcast-branco_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 197 208",
    xmlSpace: "preserve",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/react.createElement("style", null, ".canaltech-podcast-branco_svg__st0{fill:#fff}")), canaltech_podcast_branco_path || (canaltech_podcast_branco_path = /*#__PURE__*/react.createElement("path", {
    className: "canaltech-podcast-branco_svg__st0",
    d: "M80.58 59.74v19.57h16.24l9.79 9.81V59.74z"
  })), canaltech_podcast_branco_path2 || (canaltech_podcast_branco_path2 = /*#__PURE__*/react.createElement("path", {
    className: "canaltech-podcast-branco_svg__st0",
    d: "M98.5 22.22c-26.13 0-47.31 21.18-47.31 47.31 0 26.13 21.18 47.31 47.31 47.31s47.31-21.18 47.31-47.31c0-26.13-21.18-47.31-47.31-47.31zm27.71 37.52h-9.79v29.38H70.79v-39.2h55.42v9.82z"
  })), canaltech_podcast_branco_path3 || (canaltech_podcast_branco_path3 = /*#__PURE__*/react.createElement("path", {
    className: "canaltech-podcast-branco_svg__st0",
    d: "M162.55 49.83h-3.29C150.95 24.2 126.89 5.67 98.5 5.67S46.05 24.2 37.75 49.83h-3.29c-5.36 0-9.7 4.34-9.7 9.7v19.9c0 5.36 4.34 9.7 9.7 9.7h3.27c0 .01.01.03.01.04h8.77a55.443 55.443 0 01-3.58-19.65c0-30.7 24.88-55.58 55.58-55.58s55.58 24.88 55.58 55.58c0 6.92-1.27 13.54-3.58 19.65h8.77c0-.01.01-.03.01-.04h3.27c5.36 0 9.7-4.34 9.7-9.7v-19.9c-.01-5.36-4.35-9.7-9.71-9.7zM14.41 175.97a6.7 6.7 0 00-3.2.66c-.99.48-1.85 1.21-2.5 2.1a12.857 12.857 0 00-2.01 7.7c0 6.85 2.57 10.27 7.72 10.27 2.69-.1 5.34-.64 7.84-1.61v5.47a21.873 21.873 0 01-8.46 1.61c-1.9.13-3.81-.17-5.59-.88-1.77-.7-3.37-1.79-4.67-3.19C1.19 195.4 0 191.5 0 186.44c-.06-2.89.54-5.76 1.75-8.39a12.63 12.63 0 015-5.58c2.33-1.33 4.98-1.99 7.67-1.93 3.13.03 6.2.78 9 2.17l-2.1 5.29c-1.13-.54-2.29-1.02-3.47-1.43-1.11-.4-2.27-.6-3.44-.6zM41.74 201.72l-1.24-3.21h-.16A9.384 9.384 0 0137 201.4c-1.42.58-2.94.85-4.47.79a7.34 7.34 0 01-2.86-.42c-.91-.33-1.75-.84-2.46-1.51a7.405 7.405 0 01-1.98-5.57c-.08-1.07.13-2.14.59-3.1.46-.97 1.16-1.8 2.04-2.41 2.4-1.36 5.13-2.04 7.89-1.96l4.08-.13v-1.03c.06-.49.01-.99-.16-1.45-.16-.47-.43-.89-.79-1.23a3.217 3.217 0 00-2.71-.89c-2.3.1-4.56.68-6.62 1.7l-2.11-4.34c2.79-1.44 5.89-2.17 9.03-2.12 2.58-.17 5.14.56 7.25 2.06.88.78 1.56 1.75 2 2.84.44 1.09.62 2.26.53 3.43v15.66h-4.51zm-1.9-10.88l-2.48.08c-1.43-.04-2.85.3-4.1 1-.45.31-.81.74-1.05 1.23s-.35 1.04-.32 1.58c0 1.81 1.03 2.72 3.1 2.72a4.961 4.961 0 003.57-1.29c.45-.44.8-.98 1.03-1.56a4.5 4.5 0 00.3-1.85v-1.93l-.05.02zM72.78 201.72h-6.43v-13.73c.08-1.34-.24-2.66-.93-3.81a3.21 3.21 0 00-2.87-1.27c-.75-.06-1.5.07-2.18.38-.68.32-1.27.8-1.71 1.42-.95 1.84-1.37 3.9-1.21 5.96v11.04h-6.43v-23.5h4.82l.87 3.01h.35a6.777 6.777 0 012.96-2.57c1.34-.6 2.8-.89 4.28-.87a8.255 8.255 0 016.22 2.22 8.872 8.872 0 012.12 6.43v15.29h.14zM92.55 201.72l-1.24-3.21h-.18c-.86 1.21-2 2.2-3.31 2.89-1.42.58-2.94.85-4.47.79a7.34 7.34 0 01-2.86-.42c-.91-.33-1.75-.84-2.46-1.51a7.52 7.52 0 01-1.54-2.56c-.33-.95-.47-1.95-.41-2.96-.08-1.07.13-2.13.58-3.1.46-.97 1.16-1.8 2.04-2.41 2.4-1.36 5.13-2.04 7.89-1.96l4.08-.13v-1.08a3.237 3.237 0 00-.94-2.68 3.217 3.217 0 00-2.71-.89c-2.3.1-4.56.68-6.62 1.7l-2.14-4.34c2.78-1.43 5.87-2.16 9-2.12 2.58-.17 5.14.56 7.25 2.06.88.78 1.56 1.75 2 2.84.44 1.09.62 2.26.53 3.43v15.66h-4.49zm-1.9-10.88l-2.48.08c-1.45-.05-2.89.3-4.16 1.01-.45.31-.81.74-1.05 1.23s-.35 1.04-.32 1.58c0 1.81 1.03 2.72 3.1 2.72.65.03 1.3-.06 1.91-.29.61-.22 1.18-.56 1.66-1 .45-.44.8-.98 1.03-1.56a4.5 4.5 0 00.3-1.85v-1.92h.01zM108.34 201.72h-6.43v-32.69h6.43v32.69zM123.38 197.14c1.37-.05 2.73-.29 4.03-.74v4.82c-1.86.76-3.87 1.13-5.88 1.08-1.02.09-2.04-.04-3.01-.37-.96-.34-1.85-.87-2.59-1.57a8.46 8.46 0 01-1.75-5.84v-11.25h-3.07v-2.76l3.54-2.14 1.85-4.97h4.1v5h6.58v4.82h-6.58v11.25a2.54 2.54 0 00.77 2.01c.57.46 1.29.69 2.01.66zM141.13 202.25c-1.61.1-3.23-.13-4.75-.67s-2.92-1.38-4.12-2.46a11.783 11.783 0 01-2.53-4.1c-.55-1.53-.79-3.15-.69-4.77-.21-3.31.85-6.57 2.96-9.13 1.05-1.09 2.32-1.95 3.73-2.5 1.41-.55 2.92-.8 4.43-.72a10.368 10.368 0 017.75 2.83c.96 1.05 1.7 2.28 2.18 3.63.48 1.34.69 2.76.61 4.19v3.21h-15.16c-.03 1.57.55 3.1 1.61 4.26.56.54 1.22.97 1.96 1.25.73.28 1.51.4 2.29.36 1.35.01 2.7-.14 4.02-.43 1.36-.33 2.69-.81 3.95-1.41v4.82c-1.14.57-2.35.99-3.6 1.25-1.52.29-3.08.42-4.64.39zm-.9-19.78c-.6-.04-1.19.06-1.75.28-.56.22-1.05.56-1.46 1a5.97 5.97 0 00-1.32 3.67h9c.06-1.33-.38-2.64-1.24-3.67-.41-.43-.92-.77-1.48-.99-.55-.22-1.15-.32-1.75-.29zM164.31 202.25c-7.31 0-10.96-4.01-10.96-12.04-.22-3.32.85-6.6 2.99-9.15a11.24 11.24 0 018.55-3.21c2.53-.04 5.03.51 7.31 1.61l-1.9 4.97c-1.01-.41-1.95-.74-2.81-1-.84-.25-1.72-.38-2.6-.39-3.33 0-5 2.37-5 7.11s1.67 7.04 5 6.9c1.15.02 2.3-.14 3.41-.47 1.14-.38 2.23-.92 3.21-1.61v5.48c-.99.63-2.07 1.1-3.21 1.37-1.31.3-2.65.44-3.99.43zM196.99 201.84h-6.43v-13.73c0-3.39-1.26-5.08-3.78-5.08-.75-.06-1.51.07-2.19.4-.68.32-1.27.82-1.7 1.44-.94 1.83-1.35 3.88-1.21 5.93v11.06h-6.43v-32.71h6.43v6.65c0 .51-.05 1.73-.14 3.65l-.14 1.9h.34a7.361 7.361 0 012.93-2.66c1.2-.61 2.54-.87 3.88-.78 1.15-.08 2.3.08 3.38.46s2.07.99 2.91 1.77a8.83 8.83 0 012.14 6.43v15.32l.01-.05z"
  })), _g || (_g = /*#__PURE__*/react.createElement("g", null, /*#__PURE__*/react.createElement("path", {
    className: "canaltech-podcast-branco_svg__st0",
    d: "M46.57 140.66c1.82 0 3.25.67 4.3 2.01 1.05 1.34 1.58 3.21 1.58 5.61 0 2.38-.43 4.66-1.28 6.86-.85 2.2-2.02 3.94-3.5 5.22-1.48 1.29-3.11 1.93-4.89 1.93-1.03 0-1.92-.23-2.67-.69-.75-.46-1.44-1.24-2.07-2.35h-.15c-.15 1.98-.42 3.81-.8 5.5l-1.34 6.34h-5.62l6.38-30.04h4.29l-.32 3.17h.17c1.72-2.37 3.69-3.56 5.92-3.56zm-2.26 4.55c-.85 0-1.66.42-2.45 1.26-.79.84-1.42 1.96-1.9 3.36s-.72 2.94-.72 4.64c0 1 .23 1.79.69 2.39.46.6 1.09.9 1.9.9.83 0 1.63-.43 2.39-1.29.76-.86 1.37-2.04 1.84-3.54s.7-2.98.7-4.43c-.01-2.19-.82-3.29-2.45-3.29zM73.36 148.92c0 2.62-.44 4.95-1.32 6.98-.88 2.03-2.14 3.6-3.8 4.71-1.65 1.11-3.62 1.67-5.9 1.67-2.43 0-4.36-.73-5.81-2.19-1.45-1.46-2.17-3.4-2.17-5.83 0-2.65.44-5.01 1.33-7.08.89-2.07 2.17-3.68 3.85-4.81 1.68-1.14 3.64-1.71 5.9-1.71 2.44 0 4.37.73 5.78 2.2 1.43 1.47 2.14 3.49 2.14 6.06zm-5.66 0c0-2.45-.89-3.68-2.67-3.68-.93 0-1.77.38-2.51 1.14-.74.76-1.34 1.87-1.81 3.34-.47 1.47-.7 2.98-.7 4.53 0 2.3.93 3.45 2.8 3.45.93 0 1.77-.38 2.52-1.15.75-.76 1.33-1.83 1.74-3.19.42-1.35.63-2.83.63-4.44zM81.28 162.28c-1.83 0-3.27-.67-4.32-2-1.05-1.33-1.58-3.2-1.58-5.6 0-2.44.44-4.77 1.33-6.99.89-2.22 2.06-3.95 3.52-5.19 1.46-1.24 3.06-1.86 4.81-1.86 1.02 0 1.9.23 2.64.69.74.46 1.44 1.25 2.1 2.37h.15l.04-.52c.07-1.37.23-2.58.47-3.64l1.42-6.68h5.62l-6.16 29.03h-4.27l.26-2.7h-.07c-.88 1.08-1.81 1.87-2.77 2.35-.97.5-2.03.74-3.19.74zm2.35-4.53c.82 0 1.62-.43 2.4-1.28.78-.85 1.4-1.99 1.87-3.4.47-1.42.71-2.94.71-4.57 0-.99-.23-1.79-.7-2.39-.47-.6-1.1-.9-1.91-.9-.85 0-1.65.45-2.42 1.34-.77.9-1.37 2.08-1.83 3.54-.45 1.47-.68 2.92-.68 4.37.01 2.19.86 3.29 2.56 3.29zM104.36 162.28c-2.5 0-4.42-.67-5.76-2.01-1.34-1.34-2.01-3.22-2.01-5.66 0-2.64.46-5.03 1.39-7.19.93-2.16 2.23-3.82 3.91-5 1.68-1.18 3.59-1.76 5.75-1.76 2.26 0 4.3.45 6.12 1.34l-1.72 4.27c-.67-.29-1.33-.53-1.98-.75-.65-.21-1.38-.32-2.2-.32-1.06 0-2.01.4-2.86 1.19-.85.8-1.52 1.89-2 3.27-.48 1.39-.72 2.88-.72 4.47 0 1.19.28 2.09.85 2.7.57.6 1.35.9 2.36.9.95 0 1.82-.15 2.63-.44.81-.29 1.64-.66 2.5-1.09v4.59c-1.88 1-3.97 1.49-6.26 1.49zM119.53 162.28c-1.83 0-3.27-.66-4.32-1.99-1.05-1.32-1.58-3.18-1.58-5.57 0-2.46.45-4.81 1.34-7.04.9-2.23 2.07-3.96 3.53-5.19 1.46-1.22 3.05-1.84 4.79-1.84 1.21 0 2.25.26 3.12.78.88.52 1.56 1.28 2.04 2.28h.15l1.06-2.67h4.33l-4.44 20.86h-4.27l.26-2.7h-.07c-1.65 2.06-3.64 3.08-5.94 3.08zm2.2-4.53c.86 0 1.69-.42 2.48-1.25.8-.83 1.44-1.96 1.92-3.39.49-1.42.73-3.04.73-4.84 0-.88-.24-1.61-.72-2.19-.48-.58-1.11-.87-1.89-.87-.85 0-1.65.45-2.42 1.34-.77.9-1.37 2.08-1.83 3.54-.45 1.47-.68 2.92-.68 4.37 0 1.09.21 1.92.62 2.46.43.55 1.02.83 1.79.83zM148.96 155.02c0 2.34-.77 4.13-2.32 5.38-1.55 1.25-3.7 1.87-6.46 1.87-1.33 0-2.49-.09-3.48-.28-.99-.19-1.91-.5-2.77-.93v-4.63c1.95 1.12 3.94 1.68 5.95 1.68.99 0 1.81-.2 2.44-.61.63-.4.95-.95.95-1.65 0-.53-.23-1.01-.69-1.44-.46-.42-1.28-.96-2.44-1.6-1.5-.85-2.56-1.69-3.15-2.53-.6-.84-.9-1.83-.9-2.98 0-2.11.69-3.75 2.06-4.92 1.37-1.16 3.34-1.74 5.89-1.74 2.5 0 4.76.59 6.77 1.77l-1.85 4.01c-1.74-1.04-3.35-1.57-4.81-1.57-.71 0-1.28.16-1.72.48-.44.32-.65.74-.65 1.28 0 .48.2.91.6 1.28.4.37 1.14.83 2.24 1.39 1.53.78 2.64 1.64 3.32 2.56s1.02 1.99 1.02 3.18zM160.06 157.75c.81 0 1.82-.22 3.02-.65v4.2c-1.38.66-3.03.99-4.96.99-1.87 0-3.24-.39-4.11-1.18-.88-.78-1.32-2-1.32-3.64 0-.62.07-1.32.22-2.09l2.15-10.06h-2.84l.54-2.74 3.66-1.57 2.46-4.4h3.62l-.91 4.44h5.28l-.93 4.27h-5.26l-2.15 10.06c-.07.37-.11.7-.11.99 0 .92.55 1.38 1.64 1.38z"
  }))));
}
/* harmony default export */ var canaltech_podcast_branco = (SvgCanaltechPodcastBranco);
// EXTERNAL MODULE: ./src/assets/svg/podcastapple.svg
var podcastapple = __webpack_require__(3766);
// EXTERNAL MODULE: ./src/assets/svg/deezer.svg
var deezer = __webpack_require__(3168);
// EXTERNAL MODULE: ./src/assets/svg/spotify.svg
var spotify = __webpack_require__(2869);
// EXTERNAL MODULE: ./src/assets/svg/amazon.svg
var amazon = __webpack_require__(1452);
// EXTERNAL MODULE: ./src/components/Layout/Container/index.tsx
var Container = __webpack_require__(1080);
// EXTERNAL MODULE: ./src/utils/className.ts
var className = __webpack_require__(9659);
;// CONCATENATED MODULE: ./src/components/Layout/WrapperContentPodcast/index.tsx



function WrapperContentPodcast(param) {
    var children = param.children, alt = param.alt, podcast = param.podcast;
    var backgrounds = {
        porta101: {
            background_image: "https://img.canaltech.com.br/podcast_porta101_background.svg",
            background_linear: "after:[background:linear-gradient(180deg,_#59027C_0%,_rgba(89,_2,_124,_0.7)_0.01%,_#59027C_100%)]"
        },
        canaltech: {
            background_image: "https://img.canaltech.com.br/podcast_canaltech_background.svg",
            background_linear: "after:[background:linear-gradient(180deg,_rgba(12,_46,_94,_0.7)_0%,_#0C2E5E_100%)]"
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                className: "absolute bottom-0 z-[2] max-h-full w-full object-cover",
                src: backgrounds[podcast].background_image,
                alt: alt
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: (0,className/* default */.Z)('relative flex h-full w-full justify-center overflow-hidden before:absolute before:bottom-0 before:left-0 before:right-0 before:top-0 before:bg-mglGray50 before:content-[""] after:absolute after:bottom-0 after:left-0 after:right-0 after:top-0 after:z-[1] after:content-[""]', backgrounds[podcast].background_linear),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    className: "z-[2] px-0 py-10",
                    children: children
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/components/Layout/Breadcrumb/index.tsx + 1 modules
var Breadcrumb = __webpack_require__(7517);
;// CONCATENATED MODULE: ./src/components/Layout/Podcast/index.tsx









function PodcastItem(param) {
    var podcastData = param.podcastData, breadcrumbs = param.breadcrumbs;
    var platforms = [
        {
            id: 1,
            name: "Apple",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(podcastapple/* default */.Z, {
                fill: "#FFBC2F"
            }),
            title: "Apple Podcasts"
        },
        {
            id: 2,
            name: "Deezer",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(deezer/* default */.Z, {}),
            title: "Deezer"
        },
        {
            id: 4,
            name: "Spotify",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(spotify/* default */.Z, {}),
            title: "Spotify"
        },
        {
            id: 5,
            name: "Amazon",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(amazon/* default */.Z, {}),
            title: "Amazon Music"
        }, 
    ];
    var hasBreadcrumb = Object.keys(podcastData).length === 1 && breadcrumbs.length > 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            podcastData.porta101 && /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "bg-mglGray50",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperContentPodcast, {
                    podcast: "porta101",
                    alt: "Waves",
                    children: [
                        hasBreadcrumb && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "ml-0 tablet:ml-8 [&>div>div>a]:text-mglGray50 [&>div>div]:text-mglGray50 [&>div]:mt-0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default */.Z, {
                                breadcrumbList: breadcrumbs
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col text-mglGray50 desktop:flex-row [@media_(max-width:992px)]:first:mx-4 [@media_(max-width:992px)]:first:my-8 [@media_(max-width:992px)]:last:ml-0",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "m-2 flex min-w-[220px] flex-1 items-center justify-center desktop:max-w-[220px]",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: podcastData.porta101.url,
                                        title: "Playlist Podcast Porta 101",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(porta101, {
                                            width: 200,
                                            height: 200
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "ml-6 flex-1",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "mb-6 flex flex-wrap items-center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "border-0 border-r border-solid border-r-mglGray50 py-2 pl-0 pr-4 text-xs",
                                                    children: "PODCAST"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "ml-4 text-3xl font-medium",
                                                    children: "Seg"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mb-6 flex text-lg font-light",
                                            children: podcastData.porta101.descricao
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-sm font-medium",
                                            children: "Ou\xe7a j\xe1 nas plataformas"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mt-4 flex w-full flex-wrap justify-start text-mglGray50 largeDesktop:flex-nowrap largeDesktop:justify-between [&_a]:mb-2 [&_a]:ml-0 [&_a]:mr-2 [&_a]:mt-0 [&_a]:w-full [&_a]:min-w-[120px] [&_a]:max-w-[200px]",
                                            children: Object.entries(podcastData.porta101.links).map(function(link, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: link[1],
                                                    id: "pod_port_".concat(platforms[index].name.toLowerCase()),
                                                    target: "_blank",
                                                    title: "Ouvir em ".concat(platforms[index].title),
                                                    rel: "noreferrer",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                        className: "flex w-full flex-1 cursor-pointer items-center justify-center rounded-[55px] border-0 bg-mglGray900 px-4 py-2 text-xs text-mglGray50 outline-none [&_svg]:mr-2",
                                                        children: [
                                                            platforms[index].icon,
                                                            platforms[index].name
                                                        ]
                                                    })
                                                }, "".concat(platforms[index].id, "-porta"));
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            podcastData.canaltech && /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperContentPodcast, {
                    podcast: "canaltech",
                    alt: "Waves",
                    children: [
                        hasBreadcrumb && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "ml-0 tablet:ml-8 [&>div>div>a]:text-mglGray50 [&>div>div]:text-mglGray50 [&>div]:mt-0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default */.Z, {
                                breadcrumbList: breadcrumbs
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col text-mglGray50 tablet:flex-row [@media_(max-width:992px)]:first:mx-4 [@media_(max-width:992px)]:first:my-8 [@media_(max-width:992px)]:last:ml-0",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "m-2 flex min-w-[220px] flex-1 items-center justify-center desktop:max-w-[220px]",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: podcastData.canaltech.url,
                                        title: "Playlist Podcast Canaltech",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(canaltech_podcast_branco, {
                                            width: 200,
                                            height: 200
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "ml-6 flex-1",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "mb-6 flex flex-wrap items-center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "border-0 border-r border-solid border-r-mglGray50 py-2 pl-0 pr-4 text-xs",
                                                    children: "PODCAST"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "ml-4 text-3xl font-medium",
                                                    children: "Ter a S\xe1b"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mb-6 flex text-lg font-light",
                                            children: podcastData.canaltech.descricao
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-sm font-medium",
                                            children: "Ou\xe7a j\xe1 nas plataformas"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mt-4 flex w-full flex-wrap justify-start text-mglGray50 largeDesktop:flex-nowrap largeDesktop:justify-between [&_a]:mb-2 [&_a]:ml-0 [&_a]:mr-2 [&_a]:mt-0 [&_a]:w-full [&_a]:min-w-[120px] [&_a]:max-w-[200px]",
                                            children: Object.entries(podcastData.canaltech.links).map(function(link, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: link[1],
                                                    target: "_blank",
                                                    id: "pod_canaltech_".concat(platforms[index].name.toLowerCase()),
                                                    title: "Ouvir em ".concat(platforms[index].title),
                                                    rel: "noreferrer",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                        className: "flex w-full flex-1 cursor-pointer items-center justify-center rounded-[55px] border-0 bg-mglGray900 px-4 py-2 text-xs text-mglGray50 outline-none [&_svg]:mr-2",
                                                        children: [
                                                            platforms[index].icon,
                                                            platforms[index].name
                                                        ]
                                                    })
                                                }, "".concat(platforms[index].id, "-canaltech"));
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}


/***/ }),

/***/ 9879:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Titulo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _Chip__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2384);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9659);



function Titulo(param) {
    var texto = param.texto, color = param.color, urlRedirect = param.urlRedirect, showChip = param.showChip, alignRight = param.alignRight, _headingTag = param.headingTag, headingTag = _headingTag === void 0 ? "h2" : _headingTag, _noPadding = param.noPadding, noPadding = _noPadding === void 0 ? false : _noPadding;
    var titleStyles = "flex items-center text-2xl text-left font-medium";
    var Heading = headingTag;
    var chipProps = {
        black: {
            color: "black",
            border: "black",
            title: "text-mglGray900",
            hover: "black"
        },
        white: {
            color: "white",
            border: "white",
            title: "text-mglGray50",
            hover: "white"
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("flex items-center pb-2 [&>svg]:ml-[5px] [&>svg]:transition-all [&>svg]:duration-200 hover:[&>svg]:ml-[10px]", noPadding && "p-0"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Heading, {
                className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(titleStyles, !alignRight && "mr-2", chipProps[color].title),
                children: texto
            }),
            alignRight && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mr-auto"
            }),
            showChip && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Chip__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                texto: "ver tudo",
                color: chipProps[color].color,
                chipSize: "medium",
                posIcon: "chevron-right",
                title: "ver tudo - ".concat(texto),
                borderColor: chipProps[color].border,
                link: urlRedirect,
                hover: chipProps[color].hover
            })
        ]
    });
}


/***/ }),

/***/ 3078:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ WrapperContent; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _Container__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1080);
/* harmony import */ var _styles_designSystemColors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9642);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9659);




function WrapperContent(param) {
    var children = param.children, backgroundColor = param.backgroundColor, _isOnHeader = param.isOnHeader, isOnHeader = _isOnHeader === void 0 ? false : _isOnHeader, _paddingOnBottom = param.paddingOnBottom, paddingOnBottom = _paddingOnBottom === void 0 ? false : _paddingOnBottom, _paddingOnTop = param.paddingOnTop, paddingOnTop = _paddingOnTop === void 0 ? false : _paddingOnTop, _hasBreadcrumb = param.hasBreadcrumb, hasBreadcrumb = _hasBreadcrumb === void 0 ? false : _hasBreadcrumb, _mobileOnly = param.mobileOnly, mobileOnly = _mobileOnly === void 0 ? false : _mobileOnly, _desktopOnly = param.desktopOnly, desktopOnly = _desktopOnly === void 0 ? false : _desktopOnly, _className = param.className, className = _className === void 0 ? undefined : _className;
    var variants = {
        isOnHeader: {
            true: "isOnHeader [&.isOnHeader]:p-0",
            false: ""
        },
        paddingOnBottom: {
            true: "paddingOnBottom [&.paddingOnBottom]:pb-10",
            false: "pb-0"
        },
        paddingOnTop: {
            true: "paddingOnTop [&.paddingOnTop]:pt-10",
            false: ""
        },
        mobileOnly: {
            true: "flex desktop:hidden",
            false: ""
        },
        desktopOnly: {
            true: "hidden desktop:flex",
            false: ""
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        style: {
            backgroundColor: backgroundColor || _styles_designSystemColors__WEBPACK_IMPORTED_MODULE_2__/* .mglGray.mglGray50 */ .Ce.mglGray50
        },
        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("relative flex w-full flex-col flex-wrap content-center justify-center px-0 py-10", variants.isOnHeader[isOnHeader.toString()], variants.paddingOnBottom[paddingOnBottom.toString()], variants.paddingOnTop[paddingOnTop.toString()], variants.mobileOnly[mobileOnly.toString()], variants.desktopOnly[desktopOnly.toString()]),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Container__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            hasBreadcrumb: hasBreadcrumb,
            className: className,
            children: children
        })
    });
}


/***/ }),

/***/ 804:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

var PageDataContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
/* harmony default export */ __webpack_exports__["Z"] = (PageDataContext);


/***/ }),

/***/ 6874:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bw": function() { return /* binding */ sponsorCategoryData; },
/* harmony export */   "P2": function() { return /* binding */ enableSponsoredCategories; },
/* harmony export */   "PV": function() { return /* binding */ getEditorialCategory; },
/* harmony export */   "Rt": function() { return /* binding */ getSponsoredCategory; },
/* harmony export */   "SU": function() { return /* binding */ getSponsoredCategoryOrTypeWithStringToInternal; },
/* harmony export */   "xu": function() { return /* binding */ isSponsoredOrEditorialToInternal; }
/* harmony export */ });
/* unused harmony exports sponsoredCategoriesUri, getEditorialCategoryWithStringToInternal */
var sponsorCategoryData = {
    tutoriais: [
        {
            url: "https://www.kaspersky.com.br/premium?reseller=br_eg-mf_acq_ona_dis__onl_b2c_canaltech_ban_______&utm_content=banner%7Cgeneric&utm_source=canaltech&utm_medium=display&utm_term=youtube&utm_campaign=",
            title: "Ir para o site do Kaspersky!",
            image: {
                mobile: {
                    src: "https://t.ctcdn.com.br/FnVpzZ0gZiMg1_u-Eskkk_76vHo=/i990769.png",
                    blurhash: "LTS6Plt7%Mt7xufQfQay~qofIUof",
                    height: 30,
                    width: 80
                },
                desktop: {
                    src: "https://t.ctcdn.com.br/FnVpzZ0gZiMg1_u-Eskkk_76vHo=/i990769.png",
                    blurhash: "LTS6Plt7%Mt7xufQfQay~qofIUof",
                    height: 30,
                    width: 80
                }
            }
        }, 
    ],
    smartphone: [
        {
            url: "https://www.motorola.com.br/",
            title: "Ir para o site da Motorola!",
            image: {
                mobile: {
                    src: "https://t.ctcdn.com.br/VeTie34BYV2rLxS_C9-f2E2ddd8=/i1079391.png",
                    blurhash: "LTS6Plt7%Mt7xufQfQay~qofIUof",
                    height: 30,
                    width: 106
                },
                desktop: {
                    src: "https://t.ctcdn.com.br/VeTie34BYV2rLxS_C9-f2E2ddd8=/i1079391.png",
                    blurhash: "LTS6Plt7%Mt7xufQfQay~qofIUof",
                    height: 30,
                    width: 106
                }
            }
        }, 
    ]
};
var enableSponsoredCategories = [
    "tutoriais",
    "smartphone"
];
var sponsoredCategoriesUri = (/* unused pure expression or super */ null && ([
    "tutoriais",
    "smartphone"
]));
var editorialCategoriesCtupUri = [
    "hardware",
    "games",
    "ctup",
    "notebook"
];
var sponsoredCategoriesTutorialsTitle = [
    "Tutoriais"
];
var sponsoredpublicationType = [
    "4"
];
var editorialCategoriesCtupTitle = [
    "Hardware",
    "Games",
    "Notebook"
];
var editorialCategoriesCtAutoTitle = [
    "Ve\xedculos",
    "Carros",
    "Mobilidade Urbana",
    "Ve\xedculos Aut\xf4nomos"
];
var getSponsoredCategory = function(singleCategory) {
    if (singleCategory === "tutoriais") return "tutoriais";
    if (singleCategory === "smartphone") return "smartphone";
    return undefined;
};
var getEditorialCategory = function(singleCategory) {
    if (editorialCategoriesCtupUri.includes(singleCategory)) return "ctup";
    if (singleCategory === "eletro" || singleCategory === "ct-eletro") return "eletro";
    if (singleCategory === "ctauto") return "ctauto";
    return undefined;
};
var isSponsoredOrEditorialToInternal = function(mainCategory, categories) {
    var publicationType = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "1";
    if (sponsoredCategoriesTutorialsTitle.includes(mainCategory)) return "sponsored";
    if (editorialCategoriesCtupTitle.includes(mainCategory)) return "editorial";
    if (editorialCategoriesCtAutoTitle.includes(mainCategory)) return "editorial";
    if (mainCategory === "CT Eletro") return "editorial";
    if (categories.some(function(categoria) {
        return sponsoredCategoriesTutorialsTitle.includes(categoria);
    })) return "sponsored";
    if (sponsoredpublicationType.includes(publicationType)) return "sponsored";
    if (categories.some(function(categoria) {
        return editorialCategoriesCtupTitle.includes(categoria);
    })) return "editorial";
    if (categories.some(function(categoria) {
        return editorialCategoriesCtAutoTitle.includes(categoria);
    })) return "editorial";
    if (categories.includes("CT Eletro")) return "editorial";
    return undefined;
};
var getSponsoredCategoryOrTypeWithStringToInternal = function(categories, mainCategory) {
    var publicationType = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "1";
    var category = undefined;
    if (mainCategory && sponsoredCategoriesTutorialsTitle.includes(mainCategory)) category = "tutoriais";
    if (sponsoredpublicationType.includes(publicationType)) category = "tutoriais";
    if (categories.some(function(categoria) {
        return sponsoredCategoriesTutorialsTitle.includes(categoria);
    })) category = "tutoriais";
    if (!enableSponsoredCategories.includes(category)) return undefined;
    return category;
};
var getEditorialCategoryWithStringToInternal = function(categories, mainCategory) {
    var category = undefined;
    if (categories.some(function(categoria) {
        return editorialCategoriesCtupTitle.includes(categoria);
    })) category = "ctup";
    if (categories.some(function(categoria) {
        return editorialCategoriesCtAutoTitle.includes(categoria);
    })) category = "ctauto";
    if (categories.includes("CT Eletro")) category = "eletro";
    if (editorialCategoriesCtupTitle.includes(mainCategory)) category = "ctup";
    if (editorialCategoriesCtAutoTitle.includes(mainCategory)) category = "ctauto";
    if (mainCategory === "CT Eletro") category = "eletro";
    return category;
};


/***/ })

}]);